import React from 'react'
import ProjectRow1 from '../components/ProjectRow1'
import ProjectRow2 from '../components/ProjectRow2'

function Projects() {
    return (
        <div id="projects">
            <ProjectRow1 />
            <ProjectRow2 />
        </div>
    )
}

export default Projects
